import { useMemo } from 'react';
import { useOptions } from './useOptions';

export function useOptionValues(name) {
  const {
    query: { data: options },
  } = useOptions(name);

  return useMemo(
    () =>
      options.reduce(
        (accumulator, { value, label, values }) => ({
          ...accumulator,
          [value]: { label, values },
        }),
        {},
      ),
    [options],
  );
}
